
//pestañas de hotel
// format_list_bulleted;
//  <mat-icon class="white-icon">schedule</mat-icon>
//  <img src="/assets/img/app/modal/clip-check.svg" alt="" width="20px" height="20px" style="margin: 0px 2px;"> requisitos
//  <img src="/assets/img/app/modal/itinerary.svg" alt="" width="20px" height="20px" style="margin: 0px 2px;"> como llegar
//  <img src="/assets/img/app/modal/ferris.svg" alt="" width="20px" height="20px" style="margin: 0px 2px;"> atracciones
//  <img src="/assets/img/app/modal/eye.svg" alt="" width="20px" height="20px" style="margin: 0px 2px;"> Observaciones
//  <img src="/assets/img/app/modal/ayuda.svg" alt="" width="20px" height="20px" style="margin: 0px 2px;"> preguntas frecuentes
// HOTEL

export function getInfoHotel(product: any): any[] {

    return [
              {
                title: 'Tipo',
                image: 'assets/icons/search-result/hotel/TIPO.svg',
                value: 'Hotel',
              },
              {
                title: 'Niños',
                image: 'assets/icons/search-result/hotel/NIÑO.svg',
                value: product?.additionalInfo?.acceptChildren && product?.additionalInfo?.acceptChildren > 0 ? product?.additionalInfo?.acceptChildren : 'N/A',
              },
              {
                title: 'Categoría',
                image: 'assets/icons/search-result/hotel/CATEGORIA.svg',
                value: (product?.additionalInfo?.starRating != null ? String(product.additionalInfo.starRating).substring(0,1) : 'N/A'),
              },
              {
                title: 'Mascotas',
                image: 'assets/icons/search-result/hotel/MASCOTA.svg',
                value: product?.additionalInfo?.acceptPets && product?.additionalInfo?.acceptPets > 0 ? product?.additionalInfo?.acceptPets : 'N/A',
              },
              {
                title: 'Habitaciones',
                image: 'assets/icons/search-result/hotel/HABITACION.svg',
                value: product?.additionalInfo?.numberOfrooms && product?.additionalInfo?.numberOfrooms > 0 ? product?.additionalInfo?.numberOfrooms : 'N/A',
              },
              {
                title: 'Restaurante',
                image: 'assets/icons/search-result/hotel/RESTAURANTE.svg',
                value: product?.additionalInfo?.numberOfRestaurants && product?.additionalInfo?.numberOfRestaurants > 0 ? product?.additionalInfo?.numberOfRestaurants : 'N/A',
              },
              {
                title: 'Pisos',
                image: 'assets/icons/search-result/hotel/PISOS.svg',
                value: product?.additionalInfo?.numberOfFloors && product?.additionalInfo?.numberOfFloors > 0 ? product?.additionalInfo?.numberOfFloors : 'N/A',
              },
              {
                title: 'Fumador',
                image: 'assets/icons/search-result/hotel/FUMADOR.svg',
                value:  product?.additionalInfo?.suitableForSmoker ?? 'N/A',
              },
              {
                title: 'Años',
                image: 'assets/icons/search-result/hotel/AÑO.svg',
                value: product?.additionalInfo?.constructionYear && product?.additionalInfo?.constructionYear > 0 ? product?.additionalInfo?.constructionYear   : 'N/A',
              },




            ];

}

export function groupInColumns(array: any[], itemsPerColumn: number): any[][] {
  const result = [];
  for (let i = 0; i < array.length; i += itemsPerColumn) {
    result.push(array.slice(i, i + itemsPerColumn));
  }
  return result;
}

export function coverHotelsInfo(coverImage: any): any[] {
   if(coverImage && coverImage.length > 0){
      return coverImage;
    }
}

export function amenitiesHotelInfo(amenities: any): any[] {
  return amenities
                  .filter(function (amenite: any) {
                    return amenite.amenity_type === "hotel";
                  })
                  .map(function (amenite: any) {
                    return amenite;
                  });
}

export function checksTimesHotel(times: any): any[] {
  // console.log(times);

  let checkIn = times.checkIn !== null ? (times.checkIn.split(" ")[0] + ' hs') : 'N/A'
  let checkOut = times.checkOut !== null ? (times.checkOut.split(" ")[0] + ' hs') : 'N/A'

  return [
          {type: 'checkIn', text: 'Horario de check in:   ', value: `${checkIn}`},
          {type: 'checkOut', text: 'Horario de check out: ', value: `${checkOut}`}
         ]
}

export function requirementsHotel(data: any, type: string): any[] | string {

  switch (type) {
    case 'checkIn':
      return data?.checkin_requirement && Array.isArray(data?.checkin_requirement) && data?.checkin_requirement.length > 0 ? data?.checkin_requirement : [];
    case 'covid':
      return data?.covid_requirement && Array.isArray(data?.covid_requirement) && data?.covid_requirement.length > 0 ? data?.covid_requirement : [];
    case 'others':
      return data?.other_requirement && Array.isArray(data?.other_requirement) && data?.other_requirement.length > 0 ? data?.other_requirement : [];
    case 'servicesExtras':
      return data?.other_services_extra && Array.isArray(data?.other_services_extra) && data?.other_services_extra.length > 0 ? data?.other_services_extra : [];
    case 'taxes':
      return data?.rooms && Array.isArray(data?.rooms) && data?.rooms.length > 0 ? data?.rooms[0]?.room?.pricing.taxes[0] : [];
    default:
      return [];
  }

}

